export function hoursInInterval(interval: [string, string | null]): string[] {
  const [start, end] = interval;
  const startHour = parseInt(start.split(':')[0], 10);
  const startTimeTrunc = `${start.split(':')[0]}:00`;

  const endHour = parseInt(end.split(':')[0], 10);

  const hours: string[] = [];

  for (let hour = startHour; hour <= endHour; hour++) {
    const paddedHour = hour.toString().padStart(2, '0');
    const hourTrunc = `${paddedHour}:00`;

    if (hourTrunc >= startTimeTrunc && hourTrunc < end) {
      hours.push(paddedHour);
    }
  }

  return hours;
}

export function hoursInIntervals(intervals: [string, string | null][]): string[] {
  const allHours = new Set<string>();

  intervals.forEach(interval => {
    hoursInInterval(interval).forEach(hour => allHours.add(hour));
  });

  return Array.from(allHours).sort();
}

// Replace optional chaining and nullish coalescing with traditional checks
export function getValueOrDefault<T>(value: T | undefined | null, defaultValue: T): T {
  return value !== undefined && value !== null ? value : defaultValue;
}